import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Validation';

export const t = i18n(keyset);

/**
 * Keys in the Validation keyset that represent human-readable field names.
 * Validators accept one of these as the `field` argument (instead of a raw
 * localized literal) and resolve it via `t` when building an error message.
 */
export type FieldKey =
    | 'field-common'
    | 'field-name'
    | 'field-developer-name'
    | 'field-skill-name'
    | 'field-dialog-name'
    | 'field-activation-name'
    | 'field-description'
    | 'field-note'
    | 'field-subtitle'
    | 'field-id';
